/*------------------------------------*\
    MODULES
\*------------------------------------*/


/*------------------------------------*\
    TABS MODULE
\*------------------------------------*/
class Tabs {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        self.fade();
    }

    fade() {
        let self = this;

        window.addEventListener("load", function () {
            let tabItems = self.elem.querySelectorAll('.tabs__list-item');

            let myTabClicks = (tabClickEvent) => {
                for (let i = 0; i < tabItems.length; i++) {
                    tabItems[i].classList.remove("tabs__list-item--active");
                }
                let clickedTab = tabClickEvent.currentTarget;
                clickedTab.classList.add("tabs__list-item--active");
                tabClickEvent.preventDefault();
                let tabContent = self.elem.querySelectorAll('.tabs__tab');
                for (i = 0; i < tabContent.length; i++) {
                    tabContent[i].classList.remove("tabs__tab--active");
                }
                let anchorReference = tabClickEvent.target;
                let activePaneId = anchorReference.getAttribute("href");
                let activePane = self.elem.querySelector(activePaneId);
                activePane.classList.add("tabs__tab--active");
            }
            for (i = 0; i < tabItems.length; i++) {
                tabItems[i].addEventListener("click", myTabClicks)
            }
        });




    }
}

export default Tabs;